import axios from 'axios'
import store from '../store/store'
import http from '@/services/Http/http'
import i18n from '../i18n'
import { TechnicalException } from '@/services/ErrorHandler'

export default {
  userPrefferedLanguageIso2: 'en',
  async login (email, password) {
    let loginResponse = await authenticateUser(email, password)
    if (!loginResponse) {
      return false
    } else {
      store.dispatch('userdetails/setUserPackages', this.extractUserPackages(loginResponse))
    }
    let userInfo = await this.getUserDetailsInfo()
    if (userInfo) {
      await this.setLanguage()
      let userAccessToken = JSON.stringify(userInfo)
      sessionStorage.setItem('userAccessToken', userAccessToken)
      store.dispatch('userdetails/setUserInfos', userInfo)
      this.setFirstLoginPopup()
      await store.dispatch('countries/load')
      return true
    }

    return false
  },
  logout () {
    sessionStorage.removeItem('userAccessToken')
    store.dispatch('userdetails/setUserPackages', null)
    store.dispatch('userdetails/setUserInfos', null)
  },
  setFirstLoginPopup () {
    let userInfo = this.getUserInfos()
    if (userInfo) {
      store.dispatch('global/setFirstLoginPopup', userInfo.showFirstLoginPopup)
    }
  },
  getUserInfos () {
    try {
      let storageToken = JSON.parse(getUserToken())
      if (storageToken) {
        return {
          firstName: storageToken.firstName,
          lastName: storageToken.lastName,
          email: storageToken.email,
          mobilePhone: '',
          officePhone: '',
          showFirstLoginPopup: storageToken.showFirstLoginPopup
        }
      }
    } catch (e) {
      console.log(e)
      return null
    }
    return null
  },
  extractUserPackages (loginResponse) {
    let packages = []
    if (loginResponse && loginResponse.packages) {
      Object.keys(loginResponse.packages).forEach(function (key) {
        let packageItem = {
          code: key,
          keys: loginResponse.packages[key],
          KeysCount: loginResponse.packages[key].length
        }
        packages.push(packageItem)
      })
      return packages
    }
    return packages
  },
  getToken (packageName) {
    let packages = store.getters['userdetails/packages']
    if (packages) {
      try {
        let matchingPackage = packages.find(p => p.code.toUpperCase() === packageName.toUpperCase())
        if (matchingPackage && matchingPackage.keys && matchingPackage.keys.length > 0) {
          return matchingPackage.keys[0]
        } else {
          return null
        }
      } catch (e) {
        console.log(e)
        return null
      }
    }

    return null
  },
  getUserRegistrationToken () {
    return store.getters['userdetails/userRegistrationToken']
  },
  hasTokenAccess () {
    return store.getters['userdetails/hasTokenAccess']
  },
  hasClaimAccess () {
    let hasClaimPackage = store.getters['userdetails/hasClaimPackage']
    return hasClaimPackage
  },
  hasBuyerClaimAccess () {
    let hasClaimPackage = store.getters['userdetails/hasClaimPackage']
    let userInfos = store.getters['userdetails/userInfos']
    let isLinkedToBuyerClaim = !!userInfos.buyerClaimSettings && userInfos.buyerClaimSettings.isAllowed
    return hasClaimPackage && isLinkedToBuyerClaim
  },
  hasCoverageAccess () {
    let hasCoveragePackage = store.getters['userdetails/hasCoveragePackage']
    return hasCoveragePackage
  },
  hasIceAccess () {
    let hasAccess = store.getters['userdetails/hasIcePackage']
    return hasAccess
  },
  loggedIn () {
    let isAuthenticated = store.getters['userdetails/isAuthenticated']
    return isAuthenticated
  },
  async resetPassword (email) {
    let requestparams = new URLSearchParams()
    requestparams.append('email', email)
    requestparams.append('version', '3.0')
    let response = await axios.get('account/reset', { params: Object.fromEntries(requestparams) })
    return response.status === 200
  },
  async changeStatusFirstLoginPopup () {
    let params = {
      version: '2.0'
    }
    try {
      let response = await http.Account.put('account/changestatusfirstloginpopup', {}, { params })
      return response.status === 200
    } catch (e) {
      console.log(e)
      return false
    }
  },
  async confirmPassword (password, token) {
    let params = {
      version: '2.0'
    }
    let response = await axios.post('account/resetPassword', { resetPasswordToken: token, password: password }, { params })
    return response.status === 200
  },
  async getUserPackages () {
    let userToken = getUserToken()
    let packages = []
    if (userToken) {
      let params = {
        version: '2.0'
      }
      try {
        let response = await http.Account.get('account', { params })
        if (response.status === 200) {
          Object.keys(response.data.packages).forEach(function (key) {
            let packageItem = {
              code: key,
              keys: response.data.packages[key],
              KeysCount: response.data.packages[key].length
            }
            packages.push(packageItem)
          })
        }
        return packages
      } catch (e) {
        console.log(e)
        return packages
      }
    }
    return packages
  },
  async getUserDetailsInfo () {
    let params = {
      version: '2.0'
    }
    try {
      let response = await http.Account.get('/account', { params })
      if (response.status === 200) {
        this.userPrefferedLanguageIso2 = response.data.preferredLanguageIso2
        let claimExtendedFormCountries = `${process.env.VUE_APP_CLAIM_EXTENDED_FORM_COUNTRIES}`.toUpperCase().split(',')
        return {
          firstName: response.data.firstname,
          lastName: response.data.lastname,
          email: response.data.email,
          country: response.data.countryCode,
          isDeveloper: response.data.isDeveloper,
          claimExtendedForm: response.data.countryCode ? claimExtendedFormCountries.includes(response.data.countryCode.toUpperCase()) : false,
          allowedCountriesForCoverage: response.data.allowedCountriesForCoverage ? response.data.allowedCountriesForCoverage : undefined,
          showFirstLoginPopup: response.data.showFirstLoginPopup,
          customerSettings: {
            showBuyerSellerEhId: response.data.settings ? response.data.settings.showBuyerSellerEhId : false
          },
          claimSettings: {
            documentFileTypes: response.data.settings ? response.data.settings.claim.documentFileTypes : undefined,
            showCollectedAmount: response.data.countryCode && this.getShowCollectedAmountCountries().includes(response.data.countryCode.toUpperCase()),
            showDeliveryDate: response.data.countryCode && this.getShowDeliveryDateCountries().includes(response.data.countryCode.toUpperCase())
          },
          buyerClaimSettings: !!response.data.settings ? response.data.settings.buyerClaim : undefined
        }
      } else {
        return null
      }
    } catch (e) {
      console.log(e)
      return null
    }
  },
  async setLanguage () {
    try {
      var lang = this.userPrefferedLanguageIso2
      var params = {
        version: '2',
        languageCode: lang
      }

      var messages = await http.Account.get('lookups/localizedTextsByLanguage', { params })
      if (messages && messages.data && Object.keys(messages.data).length > 0) {
        let langMessages = i18n.messages[lang.toLowerCase()] || {}
        Object.entries(messages.data).forEach(([key, value]) => {
          langMessages[key] = value
        })
        i18n.setLocaleMessage(lang.toLowerCase(), langMessages)
        i18n.locale = lang.toLowerCase()
      }
    } catch (error) {
      throw new TechnicalException(error)
    }
  },
  getShowCollectedAmountCountries () {
    let sitesconfig = JSON.parse(`${process.env.VUE_APP_SITE_CONFIGURATION}`)
    return sitesconfig ? sitesconfig.showClaimCollectedAmountCountries.toUpperCase().split(',') : []
  },
  getShowDeliveryDateCountries () {
    let sitesconfig = JSON.parse(`${process.env.VUE_APP_SITE_CONFIGURATION}`)
    return sitesconfig ? sitesconfig.showClaimDeliveryDateCountries.toUpperCase().split(',') : []
  },
  getAccountUsedApikey (apikey) {
    let userToken = getUserToken()
    if (userToken) {
      let storageToken = JSON.parse(userToken)
      let accountPackage = null
      Object.keys(storageToken.packages).forEach(function (key) {
        if (key.toLowerCase() === 'Account'.toLowerCase()) {
          accountPackage = storageToken.packages[key]
        }
      })
      if (accountPackage) {
        let usedApikey = apikey
        accountPackage.forEach(function (key) {
          if (apikey !== key) {
            usedApikey = key
          }
        })
        return usedApikey
      }
    }
    return null
  },
  async refreshUserPackagesStorageWhenDeleteAccountApiKey (apikey) {
    let usedApikey = this.getAccountUsedApikey(apikey)
    if (usedApikey) {
      let userToken = getUserToken()
      let storageToken = JSON.parse(userToken)
      let params = {
        version: '2.0'
      }
      try {
        let response = await axios.get('account', { headers: { apikey: usedApikey }, params })
        if (response.status === 200) {
          storageToken.packages = response.data.packages
          let parsedStorageToken = JSON.stringify(storageToken)
          sessionStorage.removeItem('userAccessToken')
          sessionStorage.setItem('userAccessToken', parsedStorageToken)
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
  async refreshUserPackagesStorage () {
    let userToken = getUserToken()
    if (userToken) {
      let params = {
        version: '2.0'
      }
      try {
        let storageToken = JSON.parse(userToken)
        let response = await http.Account.get('account', { params })
        if (response.status === 200) {
          storageToken.packages = response.data.packages
          let parsedStorageToken = JSON.stringify(storageToken)
          sessionStorage.removeItem('userAccessToken')
          sessionStorage.setItem('userAccessToken', parsedStorageToken)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}

async function authenticateUser (email, password) {
  let params = {
    version: '3.0'
  }
  let response = await axios.post('account/login', { email: email, password: password }, { params })
  return response.status === 200 ? response.data : null
}

function getUserToken () {
  return sessionStorage.getItem('userAccessToken') || ''
}
